import { useLang } from "@/i18n";
import { Reveal } from "@/components/Reveal";
import { Seo } from "@/components/Seo";
import { Marquee } from "@/components/Marquee";

const IMGS = [
  "/img/botellas.jpg",
  null,
  null,
  null,
  "/img/impresion.jpg",
];

export default function Proceso() {
  const { t } = useLang();
  const steps = [
    { n: "01", title: t.proceso.s1t, desc: t.proceso.s1d },
    { n: "02", title: t.proceso.s2t, desc: t.proceso.s2d },
    { n: "03", title: t.proceso.s3t, desc: t.proceso.s3d },
    { n: "04", title: t.proceso.s4t, desc: t.proceso.s4d },
    { n: "05", title: t.proceso.s5t, desc: t.proceso.s5d },
  ];

  return (
    <div data-testid="process-page" className="pt-16 min-h-screen">
      <Seo page="proceso" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24">
        <Reveal>
          <h1 className="font-serif-d text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#132A1D] tracking-tight">{t.proceso.title}</h1>
          <p className="text-[#5C5C5C] mt-4 max-w-lg leading-relaxed">{t.proceso.sub}</p>
        </Reveal>
      </div>
      <Marquee />
      <div className="max-w-5xl mx-auto px-5 md:px-8 py-16 md:py-28">
        <div className="relative">
          <div className="absolute left-5 md:left-1/2 top-0 bottom-0 w-px bg-[#2E5A3B]/20" />
          <div className="space-y-20 md:space-y-28">
            {steps.map((s, i) => (
              <Reveal key={s.n} delay={0.05}>
                <div data-testid={`process-step-${s.n}`} className={`relative grid md:grid-cols-2 gap-6 md:gap-16 items-center ${i % 2 === 1 ? "" : ""}`}>
                  <div className="absolute left-5 md:left-1/2 -translate-x-1/2 w-4 h-4 rounded-full bg-[#C86A4B] ring-4 ring-[#F7F5F0]" />
                  <div className={`pl-14 md:pl-0 ${i % 2 === 0 ? "md:pr-16 md:text-right" : "md:order-2 md:pl-16"}`}>
                    <p className="font-serif-d font-light text-6xl md:text-7xl text-[#2E5A3B]/25 leading-none mb-3">{s.n}</p>
                    <h2 className="font-serif-d text-3xl md:text-4xl font-semibold text-[#132A1D] mb-3">{s.title}</h2>
                    <p className="text-[#5C5C5C] leading-relaxed">{s.desc}</p>
                  </div>
                  <div className={`pl-14 md:pl-0 ${i % 2 === 0 ? "md:order-2 md:pl-16" : "md:pr-16"}`}>
                    {IMGS[i] && (
                      <div className="overflow-hidden rounded-2xl aspect-[4/3]">
                        <img src={IMGS[i]} alt={s.title} loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
                      </div>
                    )}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
